import gql from 'graphql-tag';

const GET_EXTERNAL_PAYMENT_COUNTER = gql`
    query externalPaymentCounter ($input: ExternalPaymentCounterInput) {
        externalPaymentCounter (input: $input) {
            internalCode,
            message,
            payload {
                id,
                total,
                errors,
                success,
                created
            }
        }
    }
`;

export default GET_EXTERNAL_PAYMENT_COUNTER;
